import { PROFILE_PERMISSION_GRAPH, SSO_ENDPOINTS, SsoTicket } from '@iws/backoffice-api'

import { Model } from '@/clients/http'
import { stringifyGraph } from '@/clients/http/utils'

import { AuthHttpParams, AuthResponses } from '@/types'

export class AuthModel extends Model {
  public static readonly correlations = {
    LOGIN: 'AUTH_LOGIN',
    LOGOUT: 'AUTH_LOGOUT',
    GET_AUTH_USER: 'AUTH_USER',
  }

  public static readonly endpoints = {
    login: () => '/api/backoffice/login',
    logout: () => '/api/backoffice/logout',
    // Roles come with the profile so the app can tell what the staff member may do (AuthContext `can`).
    getAuthUser: () =>
      this.createEndpoint({ url: '/api/backoffice/profile', query: { graph_enc: stringifyGraph(PROFILE_PERMISSION_GRAPH) } }),
  }

  public static readonly login = async (props: AuthHttpParams.Login) => {
    return this.createHttpRequest<AuthResponses.Login, AuthResponses.LoginError>({
      correlationKey: this.correlations.LOGIN,
      payload: {
        method: 'post',
        url: this.endpoints.login(),
        body: props.body,
      },
      store: props.store,
    })
  }

  public static readonly logout = async (props?: AuthHttpParams.Logout) => {
    return this.createHttpRequest<void>({
      correlationKey: this.correlations.LOGOUT,
      payload: {
        method: 'post',
        url: this.endpoints.logout(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /** A one-time ticket (60 s) that signs the same staff member into pos-web, a different origin (POS.md §12.9.2). */
  public static readonly createSsoTicket = async () => {
    return this.createHttpRequest<SsoTicket>({
      correlationKey: 'CREATE_SSO_TICKET',
      payload: {
        method: 'post',
        url: this.createEndpoint({ url: SSO_ENDPOINTS.ticket }),
        body: {},
        useBearerToken: true,
      },
    })
  }

  public static readonly getAuthUser = async (props?: AuthHttpParams.GetAuthUser) => {
    return this.createHttpRequest<AuthResponses.AuthUser>({
      correlationKey: this.correlations.GET_AUTH_USER,
      payload: {
        method: 'get',
        url: this.endpoints.getAuthUser(),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
